"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PluginChecker = void 0;

var tslib_1 = require("tslib");

var PluginSetup_1 = require("./PluginSetup");

var Log_1 = require("@skbkontur/plugin-js/lib/common/Log");

var constants_1 = require("../../utils/constants");

var PluginChecker =
/** @class */
function () {
  function PluginChecker(options) {
    this.options = options;
    this.log = Log_1.LogManager.getLog(constants_1.LOG_PREFIX + "PluginChecker");
    this.pluginSetup = new PluginSetup_1.PluginSetup();
    this.timeoutId = 0;
    this.active = false;
    this.iteration = 0;
    this.completed = false;
  }

  PluginChecker.prototype.start = function () {
    if (this.active || this.completed) {
      return;
    }

    this.active = true;
    this.check();
  };

  PluginChecker.prototype.stop = function () {
    this.active = false;
    window.clearTimeout(this.timeoutId);
  };

  PluginChecker.prototype.check = function () {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      var _a, plugin, period, onComplete, onError, pluginInfo, state;

      var _this = this;

      return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.options, plugin = _a.plugin, period = _a.period, onComplete = _a.onComplete, onError = _a.onError;
            this.log.info("Plugin state check. Iteration #" + this.iteration++);
            return [4
            /*yield*/
            , plugin.getInfo()];

          case 1:
            pluginInfo = _b.sent();

            if (!this.active) {
              return [2
              /*return*/
              ];
            }

            state = this.pluginSetup.isReadyInfo(pluginInfo);

            if (state.ready) {
              this.completed = true;
              return [2
              /*return*/
              , onComplete(pluginInfo)];
            }

            onError(state.error);
            /*
             * У js-апи Плагина plugin.js есть недокументированный метод close,
             * который помогает вернуть актуальные данные о состоянии Плагина.
             */

            plugin.close();
            this.timeoutId = window.setTimeout(function () {
              _this.check();
            }, period);
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return PluginChecker;
}();

exports.PluginChecker = PluginChecker;